/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2022 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { configureStore } from "@reduxjs/toolkit";
import LogRocket from "logrocket";
import { createWrapper } from "next-redux-wrapper";
import thunkMiddleware from "redux-thunk";

import { apiMiddleware } from "./middleware/api";
import { reduxSanitizer } from "./middleware/logrocket";

import { rootReducer } from ".";

const store = configureStore({
  reducer: rootReducer,
  middleware: [thunkMiddleware, LogRocket.reduxMiddleware({ stateSanitizer: reduxSanitizer }), apiMiddleware],
});

const makeStore = () => store;

export const wrapper = createWrapper(makeStore);

export default store;
